import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withKeys as _withKeys, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-de7c9bd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "flex-ct nav" }
const _hoisted_3 = { class: "flex-ct content-botton" }
const _hoisted_4 = { class: "flex-sb search-box" }
const _hoisted_5 = { class: "font_2" }
const _hoisted_6 = {
  class: "font_3",
  style: {"text-align":"left"}
}
const _hoisted_7 = {
  class: "flex",
  style: {"width":"162px","height":"40px"}
}
const _hoisted_8 = { class: "flex-sb flutter-box" }
const _hoisted_9 = { class: "flex-sb flutter-item" }
const _hoisted_10 = { class: "flex-sb flutter-item" }
const _hoisted_11 = { class: "flex-sb flutter-item" }
const _hoisted_12 = { class: "table-box" }
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"flex-sb header\" data-v-de7c9bd6><div class=\"w-1\" data-v-de7c9bd6>医院名称</div><div class=\"w-2\" data-v-de7c9bd6>城市</div><div class=\"w-3\" data-v-de7c9bd6>医院类型</div><div class=\"w-4\" data-v-de7c9bd6>医院级别</div></div>", 1)
const _hoisted_14 = { class: "body" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "single-line-ellipsis w-1" }
const _hoisted_17 = { class: "single-line-ellipsis w-2" }
const _hoisted_18 = { class: "single-line-ellipsis w-3" }
const _hoisted_19 = { class: "single-line-ellipsis w-4" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "map",
  class: "map"
}, null, -1))

import { onMounted, ref } from "vue";
import { ElInput, ElCascader, ElSelect, ElOption } from "element-plus";
import { Search } from "@element-plus/icons-vue";
import { provinceAndCityData } from "element-china-area-data";
import { HospitalData, kidneyData } from "./config";
import AMapLoader from "@amap/amap-jsapi-loader";
import mapIcon from "@/assets/icon/map.png";
import hosptalIcon from "@/assets/icon/hosptal.png";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const showTable = ref(kidneyData);
const action = ref(1);
function changeActive(e: number) {
  action.value = e;
  showTable.value = action.value === 1 ? kidneyData : HospitalData;
  init();
  handleChange();
}

const selectedOptions0 = ref();
const selectedOptions1 = ref();
const selectedOptions2 = ref();
provinceAndCityData.unshift({ value: "全部地区", label: "全部地区" });
const regionData0 = ref(provinceAndCityData);
const regionData1 = ref(["全部医院类型"]);
const regionData2 = ref(["全部医院级别"]);
function init() {
  regionData1.value.length = 1;
  regionData2.value.length = 1;

  showTable.value.forEach((e) => {
    if (!regionData1.value.includes(e.type)) {
      regionData1.value.push(e.type);
    }
    if (!regionData2.value.includes(e.level)) {
      regionData2.value.push(e.level);
    }
  });
}
init();

const search_name = ref("");
function search() {
  selectedOptions0.value = regionData0.value[0].value;
  selectedOptions1.value = regionData1.value[0];
  selectedOptions2.value = regionData2.value[0];
  const all = action.value === 1 ? kidneyData : HospitalData;
  showTable.value = all.filter((e) => {
    const a = e.name.includes(search_name.value);
    const b = e.pname.includes(search_name.value);
    const c = e.cityname.includes(search_name.value);
    const d = e.adname.includes(search_name.value);
    return a || b || c || d;
  });
}
//切换
function handleChange() {
  console.log(
    selectedOptions0.value,
    selectedOptions1.value,
    selectedOptions2.value
  );
  const all = action.value === 1 ? kidneyData : HospitalData;
  showTable.value = all.filter((e) => {
    if (selectedOptions0.value && !selectedOptions0.value[0].includes("全部")) {
      if (!e.adcode.includes(selectedOptions0.value[1])) {
        return false;
      }
    }
    if (selectedOptions1.value && !selectedOptions1.value.includes("全部")) {
      if (e.type !== selectedOptions1.value) {
        return false;
      }
    }
    if (selectedOptions2.value && !selectedOptions2.value.includes("全部")) {
      if (e.level !== selectedOptions2.value) {
        return false;
      }
    }
    return true;
  });
}

//地图定位map.value.setCenter([lng, lat]);
function position(e: any) {
  map.value.setCenter(e.position);
  map.value.setZoom(15);
}

const map = ref<any>(null);
onMounted(async () => {
  AMapLoader.load({
    key: "98da2fba2ef1027023a833f2fbec7af7",
    version: "2.0", // 指定要加载的 JSAPI 的版本
    plugins: [
      "AMap.MarkerCluster",
      "AMap.ToolBar",
      "AMap.Scale",
      "AMap.HawkEye",
      "AMap.MapType",
    ], // 插件列表
  }).then((AMap) => {
    map.value = new AMap.Map("map", {
      center: ["113.646042", "34.752734"], // 中心点经纬度
      zoom: 5, // 缩放级别
      viewMode: "2D", //设置地图模式
    });

    //添加工具条控件，工具条控件集成了缩放、平移、定位等功能按钮在内的组合控件
    map.value.addControl(new AMap.ToolBar());

    //添加比例尺控件，展示地图在当前层级和纬度下的比例尺
    map.value.addControl(new AMap.Scale());

    //添加鹰眼控件，在地图右下角显示地图的缩略图
    map.value.addControl(new AMap.HawkEye({ isOpen: true }));

    //添加类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
    map.value.addControl(new AMap.MapType());

    const markers = HospitalData.map((point) => {
      return {
        lnglat: point.position,
        map: map.value,
      };
    });
    var styles = [
      {
        //聚合量在1-10时，聚合点的样式
        url: mapIcon, //图标显示图片的地址
        size: new AMap.Size(56, 55), //图标显示图片的大小
        offset: new AMap.Pixel(-28, -28), //图标定位在地图上的位置相对于图标左上角的偏移值
        textColor: "#fff", //文字的颜色
      },
      {
        //聚合量在10-100时，聚合点的样式
        url: mapIcon, //图标显示图片的地址
        size: new AMap.Size(56, 55), //图标显示图片的大小
        offset: new AMap.Pixel(-28, -28), //图标定位在地图上的位置相对于图标左上角的偏移值
        textColor: "#fff", //文字的颜色
      },
      {
        //聚合量在100-1000时，聚合点的样式
        url: mapIcon, //图标显示图片的地址
        size: new AMap.Size(56, 55), //图标显示图片的大小
        offset: new AMap.Pixel(-28, -28), //图标定位在地图上的位置相对于图标左上角的偏移值
        textColor: "#fff", //文字的颜色
      },
    ];

    // 初始化 MarkerCluster
    map.value!.plugin("AMap.MarkerCluster", () => {
      const markerCluster = new AMap.MarkerCluster(map.value, markers, {
        styles: styles,
      });

      // 监听聚合标记的点击事件
      markerCluster.on("click", (e: any) => {
        const markers = e.clusterData;
        if (markers.length > 1) {
          const zoomLevel = map.value.getZoom();
          map.value.setCenter(markers[0].lnglat);
          map.value.setZoom(zoomLevel + 3);
        } else {
          map.value.setCenter(markers[0].lnglat);
          map.value.setZoom(16);
        }
      });
    });
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(action.value === 1 ? 'font_1 font_1_active' : 'font_1'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (changeActive(1)))
      }, " 全国肾移植资质的医疗机构 ", 2),
      _createElementVNode("div", {
        class: _normalizeClass(action.value === 2 ? 'font_1 font_1_active' : 'font_1'),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (changeActive(2)))
      }, " 全国有器官移植资质的医疗机构 ", 2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "flex-ct table",
        style: _normalizeStyle(`background-image: url(${_unref(hosptalIcon)})`)
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(action.value === 1
                  ? "全国有肾移植资质的医疗机构"
                  : "全国有器官移植资质的医疗机构"), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(action.value === 1 ? _unref(kidneyData).length : _unref(HospitalData).length) + "家 ", 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_unref(ElInput), {
              modelValue: search_name.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((search_name).value = $event)),
              style: {"width":"240px"},
              placeholder: "搜索医院",
              "prefix-icon": _unref(Search),
              onBlur: search,
              onKeyup: _withKeys(search, ["enter"])
            }, null, 8, ["modelValue", "prefix-icon", "onKeyup"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_unref(ElCascader), {
              size: "small",
              placeholder: "所在地区",
              options: regionData0.value,
              modelValue: selectedOptions0.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedOptions0).value = $event)),
              onChange: handleChange
            }, null, 8, ["options", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_unref(ElSelect), {
              class: "flutter-item-value",
              size: "small",
              placeholder: "医院类型",
              modelValue: selectedOptions1.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedOptions1).value = $event)),
              onChange: handleChange
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(regionData1.value, (item) => {
                  return (_openBlock(), _createBlock(_unref(ElOption), {
                    key: item,
                    label: item,
                    value: item
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_unref(ElSelect), {
              placeholder: "医院级别",
              class: "flutter-item-value",
              size: "small",
              modelValue: selectedOptions2.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedOptions2).value = $event)),
              onChange: handleChange
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(regionData2.value, (item) => {
                  return (_openBlock(), _createBlock(_unref(ElOption), {
                    key: item,
                    label: item,
                    value: item
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showTable.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "flex-sb",
                key: index,
                style: {"font-size":"14px","line-height":"40px","color":"#fff","text-align":"left"},
                onClick: ($event: any) => (position(item))
              }, [
                _createElementVNode("div", _hoisted_16, _toDisplayString(item.name), 1),
                _createElementVNode("div", _hoisted_17, _toDisplayString(item.cityname), 1),
                _createElementVNode("div", _hoisted_18, _toDisplayString(item.type), 1),
                _createElementVNode("div", _hoisted_19, _toDisplayString(item.level), 1)
              ], 8, _hoisted_15))
            }), 128))
          ])
        ])
      ], 4),
      _hoisted_20
    ])
  ]))
}
}

})